<script>
  export let style = ""
</script>

<!--
@component
Shows a Close component with onClick event
-->

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
<div {style} data-testid="close-button" on:click />

<style>
  div {
    position: absolute;
    right: 0;
    box-sizing: border-box;
    padding: 8px;
    margin: 4px;
    background: #b8b8b8;
    border-radius: 15px;
    width: 10px;
    height: 10px;
    transition:
      background 0.35s,
      opacity 0.15s,
      transform 0.15s;
    cursor: pointer;
    z-index: 2;
  }
  div:hover {
    transform: rotate(90deg);
    opacity: 1;
    background: #121212;
  }

  div::before,
  div::after {
    content: "";
    width: 10px;
    height: 2px;
    border-radius: 2px;
    background: #ffffff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    right: 3px;
    top: 7px;
  }

  div::before {
    transform: rotate(-45deg);
  }

  @media screen and (max-width: 601px) {
    div {
      padding: 12px;
    }

    div::before,
    div::after {
      width: 16px;
      right: 4px;
      top: 11px;
    }
  }
</style>
